import type { CaptureOptions, PostHog, Properties } from 'posthog-js';

export type FunnelCaptureClient = Pick<PostHog, 'capture'>;

// Instant + beacon so the event survives the redirect that often follows it.
const FUNNEL_CAPTURE_OPTIONS: CaptureOptions = {
  send_instantly: true,
  transport: 'sendBeacon',
};

// Must go through the SDK: only it tags `$cookieless_mode`, without which PostHog
// stores the `$posthog_cookieless` sentinel as one person for every visitor.
export function captureFunnelEvent(
  posthog: FunnelCaptureClient | null | undefined,
  event: string,
  properties: Properties = {}
): void {
  if (!posthog) return;

  try {
    posthog.capture(event, properties, FUNNEL_CAPTURE_OPTIONS);
  } catch {
    // Never let analytics break the calling flow.
  }
}
